export default {"src":"/_next/static/media/arrowBottom.15c2e070.svg","height":8,"width":13};